
import { MapLocation } from '@/types/location';

// Legends Gaming Center Locations
export const legendsGamingCenters: MapLocation[] = [
  {
    id: 47001,
    name: "Legends Gaming - Riyadh (Al Yarmook)",
    type: "Game Center",
    devices: 2,
    coordinates: [24.80185709772399, 46.78244397791172],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
